export const LOAD_INITIAL_DATA = 'LOAD_INITIAL_DATA';
export const loadInitialData = () => ({
  type: LOAD_INITIAL_DATA
})